// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"style_tableWrapper__2Gi-H","tableTitle":"style_tableTitle__2zTOq"};